
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"170.4","height":"170.4","viewBox":"0 0 45.085 45.085","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.08 22.54c0 12.45-10.093 22.543-22.542 22.543S-.005 34.991-.005 22.54c0-12.45 10.093-22.542 22.543-22.542S45.08 10.091 45.08 22.54","fill":"#84dbff"}}),_c('path',{attrs:{"d":"M36.96 22.21H23.818l9.293-9.293-.747-.747-9.293 9.293V8.32h-1.057v13.142l-9.293-9.293-.746.747 9.292 9.293H8.125v1.057h13.142l-9.293 9.292.747.748 9.293-9.293v13.142h1.057V24.014l9.293 9.292.746-.747-9.292-9.292H36.96z","fill":"#324a5e"}}),_c('path',{attrs:{"d":"M29.17 22.54a6.63 6.63 0 11-13.261 0 6.63 6.63 0 0113.261 0","fill":"#fff"}}),_c('path',{attrs:{"d":"M27.16 22.54a4.616 4.616 0 11-9.232 0 4.616 4.616 0 019.232 0","fill":"#ff7058"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M24.82 8.32a2.283 2.283 0 11-4.567 0 2.283 2.283 0 014.567 0M24.82 36.77a2.283 2.283 0 11-4.567 0 2.283 2.283 0 014.567 0M36.76 24.83a2.283 2.283 0 110-4.567 2.283 2.283 0 010 4.567M8.32 24.83a2.283 2.283 0 110-4.566 2.283 2.283 0 010 4.566M34.21 14.1a2.282 2.282 0 11-3.229-3.227A2.282 2.282 0 0134.21 14.1M14.1 34.22a2.282 2.282 0 11-3.229-3.227A2.282 2.282 0 0114.1 34.22M30.98 34.22a2.284 2.284 0 113.23-3.229 2.284 2.284 0 01-3.23 3.229M10.87 14.1a2.284 2.284 0 113.23-3.229 2.284 2.284 0 01-3.23 3.229"}})])])
          )
        }
      }
    